export default function aiGeneratedAnswers(
  state = {
    data: {},
    isGenerating: false,
  },
  action
) {
  switch (action.type) {
    case 'SET_AI_LOADING':
      return { ...state, isGenerating: action.isGenerating }
    case 'UPDATE_AI_DATA':
      return {
        isGenerating: state.isGenerating,
        data: { ...state.data, ...action.data },
      }
    default:
      return state
  }
}
